import React, { useEffect, useRef } from 'react';

import SubNavigation from '../SubNavigation/SubNavigation';
import * as styles from './SubPageLayout.module.css';

const SubPageLayout = ({
	children,
	toc,
	tocTitle,
	activeHeading,
}: {
	children: React.ReactNode;
	toc: {
		to: string;
		label: string;
	}[];
	tocTitle?: string;
	activeHeading: string | null;
}) => {
	return (
		<div className={styles.subPageLayout}>
			<div className={styles.toc}>
				<SubNavigation activeHeading={activeHeading} toc={toc} tocTitle={tocTitle} />
			</div>
			<div>{children}</div>
		</div>
	);
};

export default SubPageLayout;
